export default __webpack_public_path__ + "static/GraphikLCWeb-Medium-4d9250eef69c1692a3768b39c2cc4e4d.woff2";